import HomeApi from '@/api/home'

const home = {
  state: {
    disablePage: [],
    companyInfo: null,
    base_api:process.env.VUE_APP_BASE_API
  },
  mutations: {
    SET_DISABLE_PAGE: (state, routers) => {
      state.routers = routers
    },
    SET_COMPANYINFO: (state, companyInfo) => {
      state.companyInfo = companyInfo
    },
    SET_BASE_API:(state,base_api)=>{
      state.base_api = base_api
    }
  },
  actions: {
    getHome ({ commit }) {
      return new Promise((resolve, reject) => {
        HomeApi.info().then((result) => {
          commit('SET_DISABLE_PAGE', result.data.disablePage)
          commit('SET_COMPANYINFO', result.data.companyInfo)
          if(result.data.companyInfo&&result.data.companyInfo.apiUrl){
             commit('SET_BASE_API', result.data.companyInfo.apiUrl)
          }
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default home
